/**
 * @author lifei
 * 功能：供应商发货通知单列表
 */
import { Service } from '@/tools'

export class ProcureSupplierInvoice<T extends TProcure.SupplierInvoice> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TProcure.SupplierInvoice}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：供应商通知列表
   * /api/procure/supplier/invoice/v1/page
   */
  page = <K extends T['ApiPage']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPage', data)

  /**
   * 功能：供应商发货通知单商品信息
   * /api/procure/supplier/invoice/v1/detailById
   */
  detailById = <K extends T['ApiDetailById']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDetailById', data)

  /**
   * 功能：供应商发货通知单详细信息
   * /api/procure/supplier/invoice/v1/selectSupplierInvoice
   */
  selectSupplierInvoice = <K extends T['ApiSelectSupplierInvoice']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectSupplierInvoice', data)

  /**
   * 功能：信息确认
   * /api/procure/supplier/invoice/v1/confirmationInfo
   */
  confirmationInfo = <K extends T['ApiConfirmationInfo']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiConfirmationInfo', data, '操作成功')

  /**
   * 功能：添加收货通知单
   * /api/procure/supplier/invoice/v1/addReceiptNoticeForm
   */
  addReceiptNoticeForm = <K extends T['ApiAddReceiptNoticeForm']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAddReceiptNoticeForm', data)

  /**
   * 功能：关联单据品种信息
   * /api/procure/supplier/invoice/v1/varietyInfo
   */
  varietyInfo = <K extends T['ApiVarietyInfo']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiVarietyInfo', data)

  /**
   * 功能：添加供应商发货通知单
   * /api/procure/supplier/invoice/v1/add
   */
  add = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data, '新增成功')

  /**
   * 功能：添加供应商发货通知单
   * /api/procure/supplier/invoice/v1/selectSupplierInvoiceDetail
   */
  selectSupplierInvoiceDetail = <K extends T['ApiSelectSupplierInvoiceDetail']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectSupplierInvoiceDetail', data)

  /**
   * 功能：导入供应商发货清单(图书)
   * /api/procure/supplier/invoice/v1/importSupplierInvoiceBook
   */
  importSupplierInvoiceBook = <K extends T['ApiImportSupplierInvoiceBook']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiImportSupplierInvoiceBook', data)

  /**
   * 功能：导入供应商发货清单(非图书)
   * /api/procure/supplier/invoice/v1/importSupplierInvoiceNotBook
   */
  importSupplierInvoiceNotBook = <K extends T['ApiImportSupplierInvoiceNotBook']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiImportSupplierInvoiceNotBook', data)

  /**
   * 功能：品种确认
   * /api/procure/supplier/invoice/v1/commodityConfirmation
   */
  commodityConfirmation = <K extends T['ApiCommodityConfirmation']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiCommodityConfirmation', data, '确认成功')

  /**
   * 功能：关联履约采购单
   *  /api/procure/supplier/invoice/v1/bindPerformancePurchaseOrder
   */
  bindPerformancePurchaseOrder = <K extends T['ApiBindPerformancePurchaseOrder']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiBindPerformancePurchaseOrder', data, '操作成功')

  /**
   * 功能：查询业务仓
   *  /api/procure/supplier/invoice/v1/selectBizWarehouseListByBizId
   */
  selectBizWarehouseListByBizId = <K extends T['ApiSelectBizWarehouseListByBizId']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectBizWarehouseListByBizId', data)

  /**
   * 功能：更新供应商发货通知单信息
   *  /api/procure/supplier/invoice/v1/updateSupplierInvoice
   */
  updateSupplierInvoice = <K extends T['ApiUpdateSupplierInvoice']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiUpdateSupplierInvoice', data, '操作成功')
}
